// extracted by mini-css-extract-plugin
export default {"container":"FavCard_container__SU-Br","card":"FavCard_card__vKId2","imgBx":"FavCard_imgBx__kPGFx","contentBx":"FavCard_contentBx__5Q2Yo"};